import { useAppSelector } from '../hooks/useAppSelector';
import * as referenceSlice from '../data/reference.slice';

export const useState = (stateId: string | undefined): string => {
  const states = useAppSelector(referenceSlice.selectStateCodes);
  const state = states.find((c) => c.stateCode === stateId);
  return state ? state.stateName : '';
};
